import { MetaTags } from "react-meta-tags";
import AboutNewPage from "../components/AboutNewPage/AboutNewPage";
const AboutNew = () => {
  return (
    <>
      <MetaTags>
        <title>
          About SaleAssist: Revolutionizing E-commerce with Live Video | Boost
          Sales and Customer Engagement | SaleAssist
        </title>
        <meta
          name="description"
          content="Discover SaleAssist, the leading live video commerce platform. We empower e-commerce businesses to engage customers, enhance customer experience, and drive sales conversions through interactive live video commerce features. Integrate seamlessly, create engaging shopping experiences, and skyrocket your conversion rates.  Start your free trial today!"
        />
        <meta
          name="keywords"
          content="live video commerce, e-commerce, ecommerce, vcommerce, customer engagement, sales conversions, live video shopping, Schedule video shopping, video streaming, online retail, customer experience, SaaS, digital marketing, live selling, shoppable video, interactive video, Video chat, Video Contact center, live shopping, video catalog, live commerce, video catalog, video tiles, video carousels, Group shopping, AI Video Commerce"
        />
      </MetaTags>
      <AboutNewPage />
    </>
  );
};

export default AboutNew;
